export default {
    default: 'default',
    italic:  'italic',
};